import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const boot = (typeof window !== "undefined" && window.__SITE_BOOT__) || {};
  const [projects, setProjects] = useState([]);
  const [modal, setModal] = useState(null); // 'enquiry' | 'site-visit' | 'brochure'

  const refresh = useCallback(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => setSettings((s) => s || {}));
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const openModal = useCallback((m) => setModal(m), []);
  const closeModal = useCallback(() => setModal(null), []);
  const flagship = projects.find((p) => p.is_flagship) || projects[0] || null;

  return (
    <SiteContext.Provider value={{ settings: settings || boot, settingsLoaded: settings !== null, projects, flagship, modal, openModal, closeModal, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
